import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Menu from './MovieMenu';

function MovieArea() {
  const [items, setItems] = useState(Menu);
  const filterItem = (categItem) => {
    const updatesItems = Menu.filter((curElem) => {

      return curElem.category === categItem;

    })

    setItems(updatesItems);
  }
  return (
    <section className="movie-area movie-bg" style={{ backgroundImage: 'url("../img/bg/movie_bg.jpg")' }}>
      <div className="container">
        <div className="row align-items-end mb-60">
          <div className="col-lg-6">
            <div className="section-title text-center text-lg-left">

              <h1 className="title">Our Services</h1>
              <div>
                &nbsp;
                &nbsp;
                &nbsp;
                <span className="sub-title">Film Production</span>
                &nbsp;
                &nbsp;
                <p>From concept to screen, we provide full-service film production for a wide range of genres, including feature films , short films, web series, documentaries and more. Our experienced team will help you bring your story to life with a focus on high production value, compelling storytelling, and visual excellence. Whether it's a fiction or non-fiction project, we manage all aspects, including pre-production planning, casting, filming, and post-production.</p>
              </div>
              <div>
                &nbsp;
                &nbsp;
                &nbsp;
                <span className="sub-title">Web Series Production</span>
                &nbsp;
                &nbsp;
                <p>In today’s digital world, web series are an engaging and effective way to tell your story. We specialize in creating binge-worthy content for online platforms, whether it's drama, comedy, or documentary-style series. Our team handles everything from scripting and casting to production and final editing, ensuring that your web series resonates with today’s viewers and stands out in the competitive online space.</p>
              </div>
              <div>
                &nbsp;
                &nbsp;
                &nbsp;
                <span className="sub-title">Documentary Production</span>
                &nbsp;
                &nbsp;
                <p>Every great documentary starts with a story that deserves to be told. At Satrang Media & Production, we work closely with you to capture the essence of your subject with authenticity and depth. From concept development to in-depth interviews, cinematography, and editing, we bring real stories to life in a way that educates, informs, and inspires audiences.</p>
              </div>
              <div>
                &nbsp;
                &nbsp;
                &nbsp;
                <span className="sub-title">Commercial & Advertising</span>
                &nbsp;
                &nbsp;
                <p>Effective advertising starts with compelling storytelling. We specialize in creating impactful commercials and branded content that capture attention and drive results. Whether you need a TV commercial, social media ad, or promotional video, we focus on creating innovative content that elevates your brand and communicates your message clearly.</p>
              </div>
              <div>
                &nbsp;
                &nbsp;
                &nbsp;
                <span className="sub-title">Casting Services</span>
                &nbsp;
                &nbsp;
                <p>Finding the right talent is essential to telling your story. Our comprehensive casting services ensure that every role, whether lead or supporting, is filled with the perfect actor or model. We work with you to source, audition, and book talent that fits your vision. From experienced actors to new faces, we pride ourselves on bringing diversity and authenticity to every project.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="movie-page-meta">
            </div>
          </div>
        </div>
        <div className="row">

        </div>
      </div>
    </section>
  )
}

export default MovieArea